export default __webpack_public_path__ + "static/media/seid.33e3c322.jpg";